module.exports = __webpack_public_path__ + "static/img/cuihua.3d37028.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cuihua.png
// module id = 5kCw
// module chunks = 74